import { useEffect, useRef } from "react"

import { useGeneralSettings } from "@/hooks/use-module-settings"

import { seedHeavyPreviewGateFromLegacyServer } from "../utils/heavy-preview-gate-storage"

/**
 * One-time migration from synced gateHeavyPreviews when localStorage has no gate state.
 * Lives at app shell so useHeavyPreviewGate stays dependency-free for settings UI.
 *
 * This mounts above the auth gate, so it renders before the settings singleton
 * exists. `useUserSettings` gates itself on that singleton (#3083); the seed
 * simply waits for settings to arrive once the query is allowed to run.
 */
export function HeavyPreviewLegacySeed(): null {
  const { settings } = useGeneralSettings()
  const done = useRef(false)

  useEffect(() => {
    if (done.current || !settings) {
      return
    }
    done.current = true
    seedHeavyPreviewGateFromLegacyServer(
      (settings as { gateHeavyPreviews?: boolean }).gateHeavyPreviews
    )
  }, [settings])

  return null
}
